import React from "react";
import Tabla from "js/components/TablaCuentaCorriente";

export const CuentaCorriente = props => {
  return (
    <div>
      <Tabla />
    </div>
  );
};

export default CuentaCorriente;
